module.exports = __webpack_public_path__ + "img/videos.5a8e6dc1.png";